import React, { Component } from "react"
import $ from "jquery"
import "jquery-ui"
import "jquery-ui/ui/widgets/sortable"
import "jquery-ui/ui/widgets/progressbar"
import "tablesorter/dist/js/jquery.tablesorter.combined"
import "./SummarySheet.css"
import "../VPLib/css/ProductSpecificUI.css"
import { Loading } from "../Loading"

const fetchFieldList = (datasetID) => {
	var webServer = "https://patstat.org/VPWeb/VPWebServer.php?"
	var command = "query"
	var strQuery = "query Field.Name, Field.NameFullCompound, Field.ID, Field.ParentFieldID, Field.ChildFieldIndex, Field.DataType, Field.DataTypeTranslated, Field.RecordViewOrder, Field.MetaTags, Field.MetaTagsTranslated, Field.Type, Field.ItemCount, Field.PercentCoverage ReturnObjects"
	var queryToFetch = webServer + command + "=" + strQuery + "&VpPubId=" + datasetID
	return fetch(queryToFetch)
		.then((response) => response.json())
		.catch((err) => {
			console.warn("Fetch Error :-S", err)
			return null
		})
}

const GetDatasetDetails = (datasetID) => {
	var strQuery = "query Dataset.SourceFile, Dataset.SourceDate, Dataset.SourceDatabase, Dataset.RecordCount ReturnObjects"
	var webServer = "https://patstat.org/VPWeb/VPWebServer.php?"
	var command = "query"
	var queryToFetch = webServer + command + "=" + strQuery + "&VpPubId=" + datasetID
	return fetch(queryToFetch)
		.then((response) => response.json())
		.catch((err) => {
			console.warn("Fetch Error :-S", err)
			return null
		})
}

function showInfo() {
	$("#datainfo").slideToggle("fast", "swing")
}

function FieldList (props) {    
	for (var data in props.datainfo) {
		var TempRecordCount = (typeof props.datainfo[data].RecordCount === "undefined") ? "" : props.datainfo[data].RecordCount
		var SourceFile = (typeof props.datainfo[data].SourceFile === "undefined") ? "" : props.datainfo[data].SourceFile
		var SourceDate = (typeof props.datainfo[data].SourceDate === "undefined") ? "" : props.datainfo[data].SourceDate
		var SourceDatabase = (typeof props.datainfo[data].SourceDataBase === "undefined") ? "" : props.datainfo[data].SourceDataBase
	}
	var ti = "Thomson Innovation - Patents (TDA format)"
	var di = "Derwent Innovation - Patents (DDA format)"
	if ((SourceDatabase.indexOf(ti) >= 0) || (SourceDatabase.indexOf(di) >= 0)) {
		//Get Raw Record Count
		var rawRecCount = 1000
		if (rawRecCount > TempRecordCount) {
			//$('#datasetType').html(_(" (Families)"));
			$("#datasetType").html(" (Families)")
		} else if (rawRecCount <= TempRecordCount) {
			//$('#datasetType').html(_(" (Publications)"));
			$("#datasetType").html(" (Publications)")
		}
	}
	var RecordCount = new Intl.NumberFormat().format(parseInt(TempRecordCount, 10))
	return (        
		<div>
			<div>
				<table id="datainfo" className="data start">
					<tbody>

						<tr>
							<td className="DataInfo"><span className="trans sourceData">Source File: </span><span id="sourcefile">{SourceFile}</span></td>
						</tr>
						<tr>
							<td className="DataInfo"><span className="trans sourceData">Source Date: </span><span id="sourcedate">{SourceDate}</span></td>
						</tr>
						<tr>
							<td className="DataInfo"><span className="trans sourceData">Source Database: </span><span id="database">{SourceDatabase}</span></td>
						</tr>
					</tbody>
				</table>
				<div className="datasetHeader">
					<span id="summary" className="head trans">Field List</span>
					<span id="datasetsummary" className="numRecs"><span className="trans">Number of Records: </span><span id="recs">{RecordCount}</span><span id="datasetType"></span></span>
					<div className="columnSelectorWrapper vertical">
						<input id="colSelect1" type="checkbox" className="hidden" />
						<label className="columnSelectorButton" htmlFor="colSelect1"><span className="trans">Columns</span></label>
						<div id="columnSelector" className="columnSelector" style={{textAlign: "left"}}></div>
					</div>
					<div id="info" onClick={showInfo}>
						<div style={{paddingLeft:10 + "px", paddingRight: 10 + "px"}} className="infoButton">i</div>
					</div>
				</div>
			</div>

			<table id="fields" className="tablesorter">
				<thead>
					<tr>
						<th id="fieldname" data-placeholder="(filters)" data-selector-name="Field" className="filter-match fieldName" data-priority="critical" title="click to sort on Field Name"><span className="trans">Field</span></th>
						<th id="itemcount" className="filter-parsed itemCountHeader" data-selector-name="Number of Items" data-priority="2"><span className="trans">Number of Items</span></th>
						<th id="pctcoverage" className="pctCoverage" data-selector-name="% Coverage" data-priority="2"><span className="trans">% Coverage</span></th>
						<th id="datatype" className="dataType" data-selector-name="Data Type" data-priority="2"><span className="trans">Data Type</span></th>
						<th id="metatags" className="metaTags" data-selector-name="Meta Tags" data-resizable="false" data-priority="2"><span className="trans">Meta Tags</span></th>
						<th id="sort" className="sort" data-priority="0" style={{display:"none"}}><span className="trans">Sort</span></th>
					</tr>
				</thead>
				<tbody id="bodyelem">
					{Object.keys(props.fields).map(function (key){
						var metaTags = props.fields[key].MetaTagTranslated
						if (typeof metaTags === "undefined"){
							metaTags = []
						}
						return(
							<tr key={props.fields[key].ID} id={"field-id-" + props.fields[key].ID} data-name={props.fields[key].Name} data-sort={props.fields[key].RecordViewOrder} data-hide={props.fields[key].MetaTag} onContextMenu={OnRightClickVP (this)} onClick={OnClickVP (this)} onDoubleClick={OnDblClickVP (this)} className={props.fields[key].Type + " field"} data-field-parent={props.fields[key].ParentFieldID} data-child-field-index={props.fields[key].ChildFieldIndex}>
								<td id={"node-" + props.fields[key].ID + "-1"} data-template-name="Name" className={props.fields[key].Type} title={props.fields[key].Name}>{props.fields[key].Name}</td>
								<td id={"node-" + props.fields[key].ID + "-2"} data-template-name="ItemCount" className="itemCount"><span data-filter={props.fields[key].ItemCount}>{new Intl.NumberFormat().format(parseInt(props.fields[key].ItemCount, 10))}</span></td>
								<td id={"node-" + props.fields[key].ID + "-3"} data-template-name="PercentCoverage" className="pctCoverage"><div id={"node-" + props.fields[key].ID + "-3b"} className="progressbar" data-value={props.fields[key].PercentCoverage}><span id={"node-" + props.fields[key].ID + "-3c"} className="progresslabel">{props.fields[key].PercentCoverage}%</span></div></td>
								<td id={"node-" + props.fields[key].ID + "-4"} data-template-name="DataType" className="dataType">{props.fields[key].DataTypeTranslated}</td>
								<td id={"node-" + props.fields[key].ID + "-5"} data-template-name="MetaTag" className="metaTags">
									<div className="noWrap">

										{metaTags.map(function(tag, index){
											if (index + 1 === metaTags.length){
												return (<span key={index}>{tag}</span>)
											}
											return (<span key={index}>{tag}, </span>)
										})}
									</div>
								</td>
								<td id={"node-" + props.fields[key].ID + "-6"} className="sort">{props.fields[key].RecordViewOrder}</td>
							</tr>
						)
					})}        
				</tbody>
			</table>
		</div>
	)
}
function InitializeTableSorter() {
	$("#showallfields").click(function() {
		if (this.checked) {
			$("#bodyelem").children().each(function(nIndex) {
				var x = ($(this).attr("data-hide")) !== undefined ? $(this).attr("data-hide") : []
				var y = ($(this).attr("data-name"))
				var z = ($(this).hasClass("filtered"))
				if (!z) {
					if (((x.indexOf("Hidden") >= 0) || (y === "~Raw Record")) && !(x.indexOf("toggled") >= 0)) {
						$(this).removeClass("hidden")
						//$(this).toggleClass('filtered');
					}
				}
			})
		} else {
			$("#bodyelem").children().each(function(nIndex) {
				var x = ($(this).attr("data-hide")) !== undefined ? $(this).attr("data-hide") : []
				var y = ($(this).attr("data-name"))
				if ((x.indexOf("Hidden") >= 0) || (y === "~Raw Record")) {
					$(this).addClass("hidden")
				}
			})
		}
		$("#fields").trigger("applyWidgets")
	})
	$("tr.parent").addClass("collapseTarget")
	$("td.parent").append("<div class=\"show collapsed showVP\"></div><div id=\"childfields\"></div>")

	$("#bodyelem").sortable({
		stop: function(e, ui) {
			$("#fields").trigger("updateCache")
			$("#fields").trigger("applyWidgets") //Update zebra stripe after sort.
			$("#fields").trigger("update", [false])
			var sorted = $(this).sortable("toArray", {
				attribute: "data-name"
			})
			EnsureFieldsAreInRightPlace()
		}
	})
	$("#fields").tablesorter({
		widthFixed: true,
		headers: {
			1: {
				sorter: "digit"
			}
		},
		// extract text from the table
		textExtraction: function(node) {
			if ($("span[data-filter]", node).length > 0) {
				return $("span[data-filter]", node).eq(0).attr("data-filter")
			} else {
				var txt = $(node).text()
				return txt === "-" ? "-0.000001" : txt
			}
		},
		showProcessing: true,
		widgets: ["zebra", "filter", "resizable", "columnSelector", "group", "stickyHeaders"],
		cssChildRow: "tablesorter-childRow",
		sortReset: true,
		emptyTo: "bottom",
		widgetOptions: {
			resizable: false,
			resizable_widths : [ "40%", "15%", "10%", "15%", "20%" ],
			filter_columnFilters: true,
			filter_hideFilters: false,
			filter_saveFilters: false,
			filter_liveSearch: true,
			filter_cssFilter: "tablesorter-filter",
			filter_childRows: true,
			filter_childByColumn: true,
			group_collapsible: true,
			group_collapsed: false,
			group_count: false,
			processAjaxOnInit: false,
			// extra class name added to the sticky header row
			stickyHeaders: "",
			// number or jquery selector targeting the position:fixed element
			stickyHeaders_offset: 0,
			// added to table ID, if it exists
			stickyHeaders_cloneId: "-sticky",
			// trigger "resize" event on headers
			stickyHeaders_addResizeEvent: true,
			// if false and a caption exist, it won't be included in the sticky header
			stickyHeaders_includeCaption: true,
			// The zIndex of the stickyHeaders, allows the user to adjust this to their needs
			stickyHeaders_zIndex: 99,
			// jQuery selector or object to attach sticky header to
			stickyHeaders_attachTo: null,
			// scroll table top into view after filtering
			stickyHeaders_filteredToTop: true,
			// target the column selector markup
			columnSelector_container: $("#columnSelector"),
			columnSelector_priority : "data-priority",
			// column status, true = display, false = hide
			// disable = do not display on list
			columnSelector_columns: {
				0: "disable",
				/*,  disabled no allowed to unselect it */
				/* 1: false // start hidden */
				5: "false" // start hidden */
			},
			// container layout
			columnSelector_layout: "<label><input type=\"checkbox\">{name}</label>"
		}
	})
		.bind("sortEnd", function(){
			EnsureFieldsAreInRightPlace()
		})
		.bind("filterStart filterEnd filterInit", function() {
			var showFields = document.getElementById("showallfields")
			if (showFields.checked) {
				$("#bodyelem").children().each(function(nIndex) {
					var x = ($(this).attr("data-hide")) !== undefined ? $(this).attr("data-hide") : []
					var y = ($(this).attr("data-name"))
					var z = ($(this).hasClass("filtered"))
					if (!z) {
						if (((x.indexOf("Hidden") >= 0) || (y === "~Raw Record")) && !(x.indexOf("toggled") >= 0)) {
							$(this).removeClass("hidden")
						}
					} else {
						if ((x.indexOf("Hidden") >= 0) || (y === "~Raw Record")) {
							$(this).addClass("hidden")
						}
					}
				})
			} else {
				$("#bodyelem").children().each(function(nIndex) {
					var x = ($(this).attr("data-hide")) !== undefined ? $(this).attr("data-hide") : []
					var y = ($(this).attr("data-name"))
					if ((x.indexOf("Hidden") >= 0) || (y === "~Raw Record")) {
						$(this).addClass("hidden")
					}
				})
			}
			$("#fields").trigger("applyWidgets")

			$(".progressbar").each(function() {
				var progressbar = $(this),
					progressLabel = $(this).find(".progresslabel")
				var value = parseInt(this.getAttribute("data-value"), 10)
				if (value <= 25) {
					$(this).addClass("redbar")
				} else if (value > 25 && value < 75) {
					$(this).addClass("yellowbar")
				} else if (value >= 75 && value <= 90) {
					$(this).addClass("lightgreenbar")
				} else {
					$(this).addClass("greenbar")
				}
				$(this).progressbar({
					value: parseInt(progressbar.attr("data-value"), 10)
				})
			})
		})
	$(".tablesorter").delegate(".collapseTarget", "click", function() {
		if ($(this).find(".show").hasClass("collapsed")) {
			var showFields = document.getElementById("showallfields")
			if (showFields.checked) {
				$(this).closest("tr").nextUntil("tr:not(.child)").removeClass("hidden")
			} else {
				$(this).closest("tr").nextUntil("tr:not(.child)").each(function() {
					if ($(this).attr("data-hide") === undefined) {
						$(this).removeClass("hidden")
					}
					else if ($(this).attr("data-hide").indexOf("Hidden") < 0) {
						$(this).removeClass("hidden")
					}
				})
			}
			$(this).closest("tr").nextUntil("tr:not(.child)").attr("data-hide", function(i, val) {
				return val.replace(", toggled", "")
			})
		} else {
			$(this).closest("tr").nextUntil("tr:not(.child)").addClass("hidden")
			$(this).closest("tr").nextUntil("tr:not(.child)").attr("data-hide", function(i, val) {
				return val + ", toggled"
			})
		}
		$(this).find(".show").toggleClass("collapsed")
		$("#fields").trigger("refreshWidgets")
		EnsureFieldsAreInRightPlace()
		return false
	})
	$("button[data-filter-column]").click(function() {
		/*** first method *** data-filter-column="1" data-filter-text="!son"
          add search value to Discount column (zero based index) input */
		var filters = [],
			$t = $(this),
			col = $t.data("filter-column"), // zero-based index
			txt = $t.data("filter-text") || $t.text() // text to add to filter
		filters[col] = txt
		// using "table.hasFilters" here to make sure we aren't targetting a sticky header
		$.tablesorter.setFilters($("table.hasFilters"), filters, true) // new v2.9
		/** old method (prior to tablsorter v2.9 ***
        var filters = $('table.tablesorter').find('input.tablesorter-filter');
        filters.val(''); // clear all filters
        filters.eq(col).val(txt).trigger('search', false);
        ******/
		/*** second method ***
          this method bypasses the filter inputs, so the "filter_columnFilters"
          option can be set to false (no column filters showing)
        ******/
		/*
        var columns = [];
        columns[5] = '2?%'; // or define the array this way [ '', '', '', '', '', '2?%' ]
        $('table').trigger('search', [ columns ]);
        */
		return false
	})   
	EnsureFieldsAreInRightPlace()
	//initially set up 'toggled' child fields
	$(".collapsed").each(function() {
		$(this).parent().closest("tr").nextUntil("tr:not(.child)")
			.addClass("hidden")
			.attr("data-hide", function(i, val) {
				return val + ", toggled"
			})
	})
}

////////////////////////////////////////////////////////////////
//
//  EnsureFieldsAreInRightPlace
//
//  Checks the fields in our table to make sure all children are
//  immediately after their parents.  Updates their
//
$("#fields").on("columnUpdate", function(){
	console.log("refresh")
	$(this).trigger("refreshColumnSelector", "selectors")
})

function EnsureFieldsAreInRightPlace() {
	var oPrevElement = null
	//
	//  We need to set aside each child we're going to work on.  If we loop through children, then
	//  as we re-insert them in different places, it messes with the loop.
	var arrChildren = []
	$("#bodyelem").children().each(function(nIndex) {
		if ($(this).hasClass("child") && $(this).attr("data-child-field-index") !== -1) {
			$(this).addClass("tablesorter-childRow")
			$(this).removeClass("draggable")
			arrChildren.push(this)
			$(this).detach()
		} else if ($(this).hasClass("tablesorter-childRow") && $(this).attr("data-hide").indexOf("Child (Inactive)") < 0) {
			$(this).attr("data-child-field-index", "-1")
			arrChildren.push(this)
			$(this).detach()
		} else if ($(this).attr("data-hide") !== undefined && $(this).attr("data-hide").indexOf("Child (Inactive)") >= 0) {
			arrChildren.push(this)
			$(this).detach()
		}
		if ($(this).attr("data-child-field-index") === -1) {
			$(this).removeClass("tablesorter-hasChildRow")
		}
	})
	var arrFullFieldName = []
	var arrInactives = []
	for (var i = 0; i < arrChildren.length; i++) {
		//
		//  Each child of bodyelem is a row.  Check the classes.
		//
		//  Children, make sure we're after our parent in order, with no non-siblings in the way.  The
		//  simplest way to do this, though not the most efficient, is to insert this immediately after
		//  its field parent (not to be confused with its HTML parent)
		//
		//  Let's sort by the child field order.  Children have that in data-child-field-index
		var oElementToInsert = arrChildren[i]
		var nMyChildFieldIndex = $(oElementToInsert).attr("data-child-field-index")
		var strParentFieldID = $(oElementToInsert).attr("data-field-parent")
		var strFieldName = $(oElementToInsert).attr("data-name")
		var oLastElementChecked = $("#field-id-" + strParentFieldID)
		var parentField = $("#field-id-" + strParentFieldID)
		var bInsertedMe = false
		//  Loop through all elements after strParentField that share the same parent (as identified by data-field-parent)
		//special case of parent field deleted
		if ($(parentField).attr("data-hide") === undefined) {
			$("#bodyelem").append(oElementToInsert)
		} else if ($(parentField).attr("data-hide").indexOf("Hidden") >= 0) {
			$(oElementToInsert).attr("data-hide", function(i, val) {
				return val + ", Hidden"
			})
		} else if ($(parentField).attr("data-hide").indexOf("Hidden") < 0) {
			//$(oElementToInsert).attr('data-hide', '{{VP.Field.MetaTags}}');
		}
		$("#field-id-" + strParentFieldID).nextAll("[data-field-parent=" + strParentFieldID + "]").each(function(nInnerIndex) {
			//For each child field, if parent field set to Hidden then set child to Hidden
			if (nMyChildFieldIndex <= $(this).attr("data-child-field-index") && !bInsertedMe) {
				if (nMyChildFieldIndex !== "-1") {
					$(this).before(oElementToInsert)
					if (arrFullFieldName[strParentFieldID] === undefined) {
						arrFullFieldName[strParentFieldID] = strFieldName
					} else {
						var tempValue = arrFullFieldName[strParentFieldID]
						arrFullFieldName[strParentFieldID] = strFieldName + " | " + tempValue
					}
				} else {
					arrInactives.push($(oElementToInsert))
					$(oElementToInsert).removeClass("group")
					$(oElementToInsert).removeClass("tablesorter-childRow")
					$(oElementToInsert).removeClass("tablesorter-hasChildRow")
				}
				bInsertedMe = true
				return
			}
			oLastElementChecked = this
		}) // end loop through field parent's children for insertion sort
		if (!bInsertedMe) {
			if (nMyChildFieldIndex !== "-1") {
				$(oLastElementChecked).after(oElementToInsert)
				if (arrFullFieldName[strParentFieldID] === undefined) {
					arrFullFieldName[strParentFieldID] = strFieldName
				} else {
					var tempValue = arrFullFieldName[strParentFieldID]
					arrFullFieldName[strParentFieldID] = tempValue + " | " + strFieldName
				}
			} else {
				arrInactives.push($(oElementToInsert))
				$(oElementToInsert).removeClass("group")
				$(oElementToInsert).removeClass("tablesorter-childRow")
				$(oElementToInsert).removeClass("tablesorter-hasChildRow")
			}
		}
		for (var y = 0; y < arrInactives.length; y++) {
			var oElementToAppend = arrInactives[y]
			if ($(parentField).find(".show").hasClass("collapsed") === false) {
				$(oElementToInsert).removeClass("hidden")
			} else {
				$(oElementToInsert).addClass("hidden")
			}
			var strOriginalParentFieldID = $(oElementToAppend).attr("data-field-parent")
			$("#field-id-" + strOriginalParentFieldID).nextAll("[data-field-parent=" + strOriginalParentFieldID + "]").last().after(oElementToAppend)
		}
		if ($(parentField).find(".show").hasClass("collapsed")) {
			$(parentField).find("#childfields").text(arrFullFieldName[strParentFieldID])
		} else {
			$(parentField).find("#childfields").text("")
		}
	}
	$("#fields").trigger("refreshWidgets")
	// end loop through children we've removed from the page
} // end EnsureFieldsAreInRightPlace

function OnRightClickVP(elem){

}

function OnClickVP(elem){

}

function OnDblClickVP(elem){

}

class SummarySheet extends Component {
	constructor(props){
		super(props)
		const datasetID = props.match.params.datasetID
		this.state = {
			fieldList: [],
			datasetDetails: [],
			datasetID: datasetID,
			loading: true,
		}

	}
	fetchData(datasetID){
		GetDatasetDetails(datasetID)
			.then((data) => {
				fetchFieldList(datasetID)
					.then((data1) => {
						this.setState({
							datasetDetails: data,
							fieldList: data1,
							loading: false
						})
						InitializeTableSorter()
					})
			})
	}
	componentDidMount(){
		this.fetchData(this.state.datasetID)
	}
	render () {
		return (
			<div className="FillWindow">
				{this.state.loading === true
					? <Loading />
					: <div>
						<div>
							<FieldList datainfo={this.state.datasetDetails} fields={this.state.fieldList} />
						</div>
						<div className="bottomPanel">
							<div className="showFieldsCheckBox">
								<input type="checkbox" id="showallfields" className="showFieldLabel" /><label htmlFor="showallfields" className="trans">Show Hidden Fields</label>
							</div>
						</div>
					</div>
				}
			</div>
		)
	}
}

export default SummarySheet